import React from 'react';
import { Container, Title, Grid, Button } from './styles';

interface SuggestionsProps {
  onQuickAction: (action: string) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({ onQuickAction }) => {
  const suggestions = [
    '🍽️ Best restaurants near me',
    '🎉 What events are happening this weekend?',
    '🎵 Live music venues nearby',
    '🏛️ Top attractions to visit',
    '🍕 Late night food options',
    '🎭 Cultural events this week',
    '🏃‍♀️ Outdoor activities around me',
    '🍷 Wine bars and lounges',
  ];

  return (
    <Container>
      <Title>You might want to ask</Title>
      <Grid>
        {suggestions.map((suggestion, index) => (
          <Button
            key={index}
            onClick={() => onQuickAction(suggestion)}
          >
            {suggestion}
          </Button>
        ))}
      </Grid>
    </Container>
  );
};

export default Suggestions;
